import React from 'react';

// Shared between the two order-detail pages (submitting a rating) and the
// two quote/offer comparison cards (displaying a provider's existing
// average) — same reasoning SearchWidgets.jsx was extracted for: one real
// UI piece needed in more than one place, not a per-page label map.
const StarRating = ({ value = 0, onChange, readOnly = false, size = 'text-2xl' }) => {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className={`flex items-center gap-1 ${readOnly ? '' : 'cursor-pointer'}`} dir="ltr">
      {stars.map((n) => (
        <span
          key={n}
          onClick={readOnly ? undefined : () => onChange(n)}
          className={`${size} leading-none transition-colors ${n <= Math.round(value) ? 'text-amber-400' : 'text-gray-200'}`}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating;
